import React from "react";
import { RequireRole } from "../../app/router/RequireRole";
import { AgendaPage } from "./pages/AgendaPage";
import { ClassDetailPage } from "./pages/ClassDetailPage";
import { AttendancePage } from "./pages/AttendancePage";
import { GradeCardPage } from "./pages/GradeCardPage";
import { TeacherHoursPage } from "./pages/TeacherHoursPage";

/**
 * Teacher feature routes — TASK-12 (R6: owned exclusively by src/features/teacher/).
 *
 * ── Protected (RequireRole TEACHER) ───────────────────────────────────────────
 *   /:slug/app/agenda                       AgendaPage      — lista + crear clase
 *   /:slug/app/agenda/:planningId           ClassDetailPage — detalle + continuidad
 *   /:slug/app/agenda/:planningId/asistencia AttendancePage — roster + marcar asistencia
 *   /:slug/app/agenda/:planningId/grade-card GradeCardPage  — grade card UI móvil-first
 *   /:slug/app/mis-horas                    TeacherHoursPage — horas pendientes
 *
 * Register in AppRouter.js (one line — R6):
 *   import teacherRoutes from '../../features/teacher/routes';
 *   registry.register(teacherRoutes);
 */
const teacherRoutes = [
  {
    path: "/:slug/app/agenda",
    element: <RequireRole roles={["TEACHER"]} />,
    children: [
      { index: true, element: <AgendaPage /> },
      { path: ":planningId", element: <ClassDetailPage /> },
      { path: ":planningId/asistencia", element: <AttendancePage /> },
      { path: ":planningId/grade-card", element: <GradeCardPage /> },
    ],
  },
  {
    path: "/:slug/app/mis-horas",
    element: <RequireRole roles={["TEACHER"]} />,
    children: [{ index: true, element: <TeacherHoursPage /> }],
  },
];

export default teacherRoutes;
